import {AiChatPublishType, GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {closeAiActionLoadingModal, isCurrentModalSession, openPublishingLoadingModalAndGetSessionId, showPublishingReadyModal} from '@Components/ai-chat-window/lib/ai-action-loading-modal.library';
import {getPosterHashedIdForAiChatImageAsset} from '@Components/ai-chat-window/lib/chat-attachment-image.library';
import {getEventWizardURLWithDesignPrefill} from '@Libraries/events.library';
import {MediaTypes} from '@Components/event-wizard/event-wizard-image-video/event-wizard-image-video.types';
import {isUserPAYG} from '@Libraries/user.library';
import {openUpsellingDialogForEmailCampaigns} from '@Libraries/email-campaigns-library';
import {PublishingOption} from '@Components/ai-chat-window/components/publishing-options/publishing-options.types';

type PosterUrlBuilder = (posterHashedId: string) => string;

const GA4_PUBLISH_TYPE: Record<PublishingOption, AiChatPublishType> = {
  [PublishingOption.PUBLISH_TO_SOCIAL_MEDIA]: AiChatPublishType.SOCIAL_MEDIA,
  [PublishingOption.PROMOTE_AS_EVENT]: AiChatPublishType.EVENT,
  [PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN]: AiChatPublishType.EMAIL,
};

const publishDesign = async (option: PublishingOption, buildUrl: PosterUrlBuilder, imageHashedId: string): Promise<void> => {
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_PUBLISH, {[GA4EventParamName.TYPE]: GA4_PUBLISH_TYPE[option]});

  const sessionId = openPublishingLoadingModalAndGetSessionId(option);

  try {
    const posterHashedId = await getPosterHashedIdForAiChatImageAsset(imageHashedId);

    if (!isCurrentModalSession(sessionId)) {
      return;
    }

    showPublishingReadyModal(option, {url: buildUrl(posterHashedId), openInNewTab: true});
  } catch (e: unknown) {
    if (isCurrentModalSession(sessionId)) {
      closeAiActionLoadingModal();
    }

    throw e;
  }
};

export const postDesignOnSocialMedia = async (imageHashedId: string): Promise<void> => {
  await publishDesign(
    PublishingOption.PUBLISH_TO_SOCIAL_MEDIA,
    (posterHashedId) => {
      return window.PMW.util.site_url(`socialmedia/post/design/${posterHashedId}`);
    },
    imageHashedId
  );
};

export const promoteDesignAsEvent = async (imageHashedId: string): Promise<void> => {
  await publishDesign(
    PublishingOption.PROMOTE_AS_EVENT,
    (posterHashedId) => {
      return getEventWizardURLWithDesignPrefill(posterHashedId, MediaTypes.MY_DESIGNS);
    },
    imageHashedId
  );
};

export const sendDesignAsEmail = async (imageHashedId: string): Promise<void> => {
  if (isUserPAYG()) {
    openUpsellingDialogForEmailCampaigns();

    return;
  }

  await publishDesign(
    PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN,
    (posterHashedId) => {
      return window.PMW.util.site_url(`emailmarketing/publish/design/${posterHashedId}`);
    },
    imageHashedId
  );
};
